/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100vw;height:100vh;display:block;position:relative;margin-top:-56px}iframe[_ngcontent-%COMP%]{width:100%;height:100%;border:none}"];
export { styles as styles };
//# sourceMappingURL=account-sharing-page.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/account-sharing/account-sharing-page/account-sharing-page.component.scss.shim.ngstyle.js
// module id = 1422
// module chunks = 27 28 29